export const MODULES = {
  fex: { key: 'fex', title: 'Entregables Fexería', route: 'fexeria-entregables', configTab: 'fexeria' },
  com: { key: 'com', title: 'Entregables Comerciales', route: 'fexeria-comerciales', configTab: 'comerciales' },
};

// `stage` 1..5 en cada entregable; 0 = fuera de la ruta.
export const STAGES = [
  { name: 'Diagnóstico', desc: 'El punto de partida: cómo opera hoy tu empresa.' },
  { name: 'Arquitecturas', desc: 'El diseño de tus procesos comerciales y el recorrido por tu cadena de valor.' },
  { name: 'OKRs', desc: 'Los objetivos y resultados clave con los que se medirá el éxito.' },
  { name: 'Demo', desc: 'La plataforma configurada con tus procesos, lista para probar.' },
  { name: 'Entrega', desc: 'Actas de aprobación de cada proceso y cierre formal del proyecto.' },
];

export const JOURNEY_TYPES = ['Flujo Principal', 'Soporte'];

// El back acepta cualquier archivo salvo ejecutables y scripts (máx. 100 MB) y valida el resto.
export const FILE_ACCEPT = '*/*';
export const acceptFor = () => FILE_ACCEPT;
export const FILE_MAX_MB = 100;

export const TOAST_MS = 3200;
